import { Box, Button, styled, Typography, Divider } from "@mui/material";
import { useState } from "react";
import { useTrendStats } from "@/hooks/use-trend-stats";
import { CustomButton } from "@/components/custom/custom-button";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { TrendChart } from "./transaction-trend-chart";

const PeriodButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== "isActive",
})(({ theme, isActive }) => ({
  minWidth: 48,
  height: 32,
  borderRadius: 20,
  fontSize: "0.8rem",
  textTransform: "none",
  fontWeight: isActive ? 600 : 400,
  backgroundColor: isActive ? theme.palette.primary.main : "transparent",
  color: isActive ? "#fff" : theme.palette.text.secondary,
  "&:hover": {
    backgroundColor: isActive
      ? theme.palette.primary.main
      : theme.palette.action.hover,
  },
}));

const PeriodSelector = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255,255,255,0.08)"
      : theme.palette.grey[100],
  borderRadius: 20,
  padding: 4,
  width: "fit-content",
  gap: 2,
}));

const GridItem = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: "12px",
  borderRadius: "8px",
}));

const GridItemSpan2 = styled(GridItem)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  gridColumn: "span 2",
}));

const periods = ["7d", "14d", "30d", "60d", "90d"];

const TransactionTrend = () => {
  const [period, setPeriod] = useState("30d");
  const { data, isLoading } = useTrendStats(period);

  return (
    <GridItemSpan2>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 2,
          px: 1,
        }}
      >
        <Box>
          <Typography variant="h6" fontWeight={700}>
            Transaction trend
          </Typography>

          <Typography variant="body2" color="text.secondary">
            {data?.label}
          </Typography>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <PeriodSelector>
            {periods.map((p) => (
              <PeriodButton
                key={p}
                isActive={period === p}
                onClick={() => setPeriod(p)}
              >
                {p}
              </PeriodButton>
            ))}
          </PeriodSelector>

          <Divider orientation="vertical" flexItem />

          <CustomButton
            variantType="outline"
            endIcon={<FileDownloadOutlinedIcon fontSize="small" />}
            onClick={() => console.log("export")}
            sx={{ height: 35 }}
          >
            Export
          </CustomButton>
        </Box>
      </Box>
      <TrendChart data={data} isLoading={isLoading} />
    </GridItemSpan2>
  );
};
export default TransactionTrend;
